import styled from 'styled-components';

import { ArticleGridSection } from 'components/cms-blocks/article-grid/styles';
import { HeadingWrapper } from 'components/common/text';

export const BlocksWrapper = styled.div`
  ${ArticleGridSection} ${HeadingWrapper} {
    justify-content: center;
  }
`;
